export default "__VITE_ASSET__BIpvsQmk__"